import PropTypes from 'prop-types';
import Language from '../../../../v2/lang/language';

const MoreOrLessButton = (props) => {
  const renderDiv = text => (
    <div className="referralsSocialSharing_more" onClick={props.toggleExpand}>{text}</div>
  );
  if (!props.isExpanded && props.hasOverflowingContent) {
    return renderDiv(Language.getText('referralsSocialSharing.more'));
  }
  if (props.isExpanded && props.hasExpandedContent) {
    return renderDiv(Language.getText('referralsSocialSharing.less'));
  }
  return null;
};

MoreOrLessButton.propTypes = {
  hasExpandedContent: PropTypes.bool.isRequired,
  hasOverflowingContent: PropTypes.bool.isRequired,
  isExpanded: PropTypes.bool.isRequired,
};

export default MoreOrLessButton;
